/* HYDRAVE theme behaviour */

/* ---------------- product slider ---------------- */
function hvSlider(root) {
  var track = root.querySelector('[data-track]');
  var slides = root.querySelectorAll('[data-slide]');
  if (!track || !slides.length) return null;

  var dotsWrap = root.querySelector('[data-dots]');
  var thumbs = root.querySelectorAll('[data-goto]');
  var prev = root.querySelector('[data-prev]');
  var next = root.querySelector('[data-next]');
  var current = root.querySelector('[data-current]');
  var total = root.querySelector('[data-total]');
  var i = 0;

  if (total) total.textContent = slides.length;

  if (dotsWrap && !dotsWrap.children.length && slides.length > 1) {
    for (var d = 0; d < slides.length; d++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-dot', d);
      b.setAttribute('aria-label', 'Go to image ' + (d + 1));
      dotsWrap.appendChild(b);
    }
  }
  var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-dot]') : [];

  function go(n) {
    i = Math.max(0, Math.min(slides.length - 1, n));
    track.style.transform = 'translateX(' + (-100 * i) + '%)';
    if (current) current.textContent = i + 1;
    for (var a = 0; a < dots.length; a++) dots[a].setAttribute('aria-current', a === i ? 'true' : 'false');
    for (var t = 0; t < thumbs.length; t++) thumbs[t].setAttribute('aria-current', t === i ? 'true' : 'false');
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-prev]')) return go(i - 1);
    if (e.target.closest('[data-next]')) return go(i + 1);
    var dot = e.target.closest('[data-dot]');
    if (dot) return go(parseInt(dot.getAttribute('data-dot'), 10));
    var th = e.target.closest('[data-goto]');
    if (th) return go(parseInt(th.getAttribute('data-goto'), 10));
  });

  /* keyboard */
  root.setAttribute('tabindex', '0');
  root.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
  });

  /* touch swipe */
  var x0 = null;
  var vp = root.querySelector('.slider__viewport') || root;
  vp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  vp.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
    x0 = null;
  }, { passive: true });

  go(0);
  return { go: go };
}

/* ---------------- bundle tiers ---------------- */
function hvSyncTier(root) {
  var checked = root.querySelector('[data-tier] input:checked');
  if (!checked) return;
  var tier = checked.closest('[data-tier]');
  var qty = root.querySelector('[data-bundle-qty]');
  var ret = root.querySelector('[data-bundle-return]');
  if (qty) qty.value = tier.dataset.qty || '1';
  if (ret) ret.value = tier.dataset.code ? '/cart?discount=' + encodeURIComponent(tier.dataset.code) : '/cart';
  root.querySelectorAll('[data-tier]').forEach(function (t) {
    var on = t === tier;
    t.style.borderColor = on ? 'var(--blue)' : 'var(--line)';
    t.style.boxShadow = on ? 'inset 0 0 0 1px var(--blue)' : 'none';
  });
}

var hvSliders = [];

document.addEventListener('change', function (e) {
  var root = e.target.closest('[data-bundle]');
  if (root) hvSyncTier(root);
});

document.addEventListener('click', function (e) {
  /* variant photo swatches */
  var sw = e.target.closest('[data-variant]');
  if (sw) {
    var group = sw.closest('[data-variant-group]');
    group.querySelectorAll('[data-variant]').forEach(function (b) { b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); });
    var input = group.querySelector('input[name="id"]');
    if (input) input.value = sw.dataset.variant;
    var price = document.querySelector('[data-price-target]');
    if (price && sw.dataset.price) price.textContent = sw.dataset.price;
    var was = document.querySelector('[data-compare-target]');
    if (was) { was.textContent = sw.dataset.compare || ''; }
    var atc = document.querySelector('[data-atc-label]');
    if (atc && sw.dataset.price) atc.textContent = 'Add to cart — ' + sw.dataset.price;
    var nm = document.querySelector('[data-variant-name]');
    if (nm) nm.textContent = sw.dataset.title || '';
    if (sw.dataset.slideIndex && hvSliders[0]) hvSliders[0].go(parseInt(sw.dataset.slideIndex, 10));
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', sw.dataset.variant);
      window.history.replaceState({}, '', url);
    } catch (err) {}
  }

  /* demo swatches update the name label */
  var demo = e.target.closest('.swatch--photo[data-goto]');
  if (demo) {
    var g = demo.closest('div');
    if (g) g.querySelectorAll('.swatch--photo').forEach(function (b) { b.setAttribute('aria-pressed', b === demo ? 'true' : 'false'); });
    var label = document.querySelector('[data-variant-name]');
    var txt = demo.querySelector('span');
    if (label && txt) label.textContent = txt.textContent.trim();
  }

  /* bundle tier click anywhere */
  var tier = e.target.closest('[data-tier]');
  if (tier) {
    var radio = tier.querySelector('input[type="radio"]');
    if (radio && !radio.checked) { radio.checked = true; hvSyncTier(tier.closest('[data-bundle]')); }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-slider]').forEach(function (s) {
    var api = hvSlider(s);
    if (api) hvSliders.push(api);
  });
  document.querySelectorAll('[data-bundle]').forEach(hvSyncTier);
});

/* ---------------- reviews ---------------- */
function hvReviews(root) {
  var src = root.dataset.src;
  var per = parseInt(root.dataset.perPage, 10) || 9;
  var grid = root.querySelector('[data-rv-grid]');
  var bars = root.querySelector('[data-rv-bars]');
  var avgEl = root.querySelector('[data-rv-avg]');
  var totEl = root.querySelector('[data-rv-total]');
  var moreBtn = root.querySelector('[data-rv-more]');
  var sortSel = root.querySelector('[data-rv-sort]');
  var all = [], view = [], shown = 0, filter = 'all', sort = 'recent';

  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function stars(n) { var o = ''; for (var i = 0; i < 5; i++) o += i < n ? '\u2605' : '\u2606'; return o; }
  function initials(name) { return name.split(/\s+/).map(function (w) { return w[0]; }).join('').slice(0, 2).toUpperCase(); }
  function when(d) {
    var t = new Date(d + 'T00:00:00');
    return t.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  function assetPath(file) {
    var base = src.split('reviews.json')[0];
    return base + file;
  }

  function card(r) {
    var av = r.avatar
      ? '<img class="rv-card__av" src="' + assetPath(r.avatar) + '" alt="' + esc(r.name) + '" width="38" height="38" loading="lazy">'
      : '<span class="rv-card__initials" aria-hidden="true">' + initials(r.name) + '</span>';
    var photo = r.photo
      ? '<img class="rv-card__photo" src="' + assetPath(r.photo) + '" alt="Photo from ' + esc(r.name) + '" width="400" height="300" loading="lazy">'
      : '';
    return '<figure class="rv-card">' +
      '<div class="rv-card__head">' + av +
        '<span class="rv-card__who"><span class="rv-card__name">' + esc(r.name) + '</span>' +
        (r.verified ? '<span class="rv-card__ver">' + (root.dataset.verifiedBadge || '\u2713 Verified purchase') + '</span>' : '') + '</span>' +
        '<span class="rv-card__stars">' + stars(r.stars) + '</span>' +
      '</div>' +
      '<blockquote class="rv-card__body">' + esc(r.body) + '</blockquote>' + photo +
      '<figcaption class="rv-card__foot"><span>' + when(r.date) + '</span>' +
        '<span>' + esc(r.colour) + '</span>' +
        '<span style="margin-left:auto">' + r.helpful + ' ' + (root.dataset.helpfulWord || 'found helpful') + '</span></figcaption>' +
    '</figure>';
  }

  function applyFilter() {
    view = all.filter(function (r) {
      if (filter === 'all') return true;
      if (filter === 'photos') return !!r.photo;
      return r.stars === parseInt(filter, 10);
    });
    var cmp = {
      recent: function (a, b) { return b.date.localeCompare(a.date); },
      helpful: function (a, b) { return b.helpful - a.helpful; },
      high: function (a, b) { return b.stars - a.stars || b.date.localeCompare(a.date); },
      low: function (a, b) { return a.stars - b.stars || b.date.localeCompare(a.date); }
    }[sort];
    view.sort(cmp);
    shown = 0;
    grid.innerHTML = '';
    render();
  }

  function render() {
    if (!view.length) {
      grid.innerHTML = '<p class="rv-empty lede">' + (moreBtn.dataset.emptyLabel || 'No reviews match that filter yet.') + '</p>';
      moreBtn.hidden = true;
      return;
    }
    var next = view.slice(shown, shown + per);
    grid.insertAdjacentHTML('beforeend', next.map(card).join(''));
    shown += next.length;
    moreBtn.hidden = shown >= view.length;
    moreBtn.textContent = 'Load more reviews (' + (view.length - shown) + ' left)';
  }

  fetch(src).then(function (r) { return r.json(); }).then(function (data) {
    all = data.reviews || [];
    var total = (data.summary && data.summary.total) || all.length;
    var avg = (data.summary && data.summary.average) || (all.reduce(function (a, r) { return a + r.stars; }, 0) / all.length);
    if (avgEl) avgEl.textContent = Number(avg).toFixed(1);
    if (totEl) totEl.textContent = total.toLocaleString('en-US') + ' ' + (root.dataset.reviewsWord || 'reviews');
    if (bars) {
      bars.innerHTML = [5, 4, 3, 2, 1].map(function (s) {
        var n = all.filter(function (r) { return r.stars === s; }).length;
        var pct = all.length ? Math.round(n / all.length * 100) : 0;
        return '<div class="rv-bar"><span>' + s + '\u2605</span>' +
          '<span class="rv-bar__track"><span class="rv-bar__fill" style="width:' + pct + '%"></span></span>' +
          '<span class="rv-bar__pct">' + pct + '%</span></div>';
      }).join('');
    }
    applyFilter();
  }).catch(function () {
    grid.innerHTML = '<p class="rv-empty lede">' + (moreBtn.dataset.errorLabel || 'Reviews could not load.') + '</p>';
    if (totEl) totEl.textContent = '';
  });

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-filter]');
    if (chip) {
      filter = chip.dataset.filter;
      root.querySelectorAll('[data-filter]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      applyFilter();
    }
    if (e.target.closest('[data-rv-more]')) render();
  });
  if (sortSel) sortSel.addEventListener('change', function () { sort = sortSel.value; applyFilter(); });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-reviews]').forEach(hvReviews);
});

/* ---------------- mobile nav drawer ---------------- */
(function () {
  function bind() {
    var btn = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    var scrim = document.querySelector('[data-nav-scrim]');
    if (!btn || !nav) return;
    function setOpen(open) {
      nav.setAttribute('data-open', open ? 'true' : 'false');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (scrim) scrim.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    btn.addEventListener('click', function () {
      setOpen(nav.getAttribute('data-open') !== 'true');
    });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 900) setOpen(false); });
  }
  document.addEventListener('DOMContentLoaded', bind);
})();

/* ---------------- sticky mobile add-to-cart ---------------- */
(function () {
  function build() {
    var form = document.querySelector('#pdp-form');
    if (!form) return;
    var submit = form.querySelector('button[type="submit"]');
    var title = document.querySelector('.pdp__pane h1');
    var price = document.querySelector('[data-price-target]');
    if (!submit || !title) return;

    var bar = document.createElement('div');
    bar.className = 'atc-bar';
    bar.innerHTML =
      '<span class="atc-bar__info">' +
        '<span class="atc-bar__name"></span>' +
        '<span class="atc-bar__price"></span>' +
      '</span>' +
      '<button type="button" class="btn btn--blue"></button>';
    document.body.appendChild(bar);
    document.body.classList.add('has-atc-bar');

    var nameEl = bar.querySelector('.atc-bar__name');
    var priceEl = bar.querySelector('.atc-bar__price');
    var btn = bar.querySelector('button');

    function sync() {
      nameEl.textContent = title.textContent.trim();
      priceEl.textContent = price ? price.textContent.trim() : '';
      btn.disabled = submit.disabled;
      var lbl = form.getAttribute('data-atc-text') || 'Add to cart';
      var out = form.getAttribute('data-soldout-text') || 'Sold out';
      btn.textContent = submit.disabled ? out : lbl;
    }
    sync();
    btn.addEventListener('click', function () {
      if (submit.disabled) return;
      form.requestSubmit ? form.requestSubmit(submit) : submit.click();
    });
    document.addEventListener('click', function () { setTimeout(sync, 60); });

    /* hide the bar while the real button is on screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.style.transform = entries[0].isIntersecting ? 'translateY(110%)' : 'translateY(0)';
      }, { threshold: 0.4 }).observe(submit);
      bar.style.transition = 'transform .25s ease';
    }
  }
  document.addEventListener('DOMContentLoaded', build);
})();
